import { CustomerBrowserData, BoipaAuthTypeEnum } from '@up/data';
export type BoipaAuthTokenRequestDataDto = {
  action: BoipaAuthTypeEnum;
  currency: string;
  merchantTxId: string;
  paymentSolutionId: string;
  customerId?: number | string;
  nameOnCard?: string;
  customerFirstName?: string;
  customerLastName?: string;
  customerEmail?: string;
  amount?: number;
  merchantReference?: string;
  storeCard?: boolean;
  cardToken?: string;
  initialTransactionId?: string;
  customerBrowserData?: CustomerBrowserData;
  entity?: string;
  paymentMethodId?: number;
  successUrl?: string;
  failUrl?: string;
  userId?: number;
  cardOnFileInitiator?: string;
  cardOnFileReason?: string;
  cardOnFileType?: string;
};
